/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const capacityPerformanceEnumsCapacityAndPerformanceCurrentStatusOptionEnum = {
    Online: 'Online',
    Offline: 'Offline',
    WorkingWithErrors: 'WorkingWithErrors',
    RunningInManualMode: 'RunningInManualMode',
    Other: 'Other',
} as const;

export type CapacityPerformanceEnumsCapacityAndPerformanceCurrentStatusOptionEnumKey =
    (typeof capacityPerformanceEnumsCapacityAndPerformanceCurrentStatusOptionEnum)[keyof typeof capacityPerformanceEnumsCapacityAndPerformanceCurrentStatusOptionEnum];

export type CapacityPerformanceEnumsCapacityAndPerformanceCurrentStatusOption =
    CapacityPerformanceEnumsCapacityAndPerformanceCurrentStatusOptionEnumKey;
